import { Container } from "@material-ui/core";

import { useTenant } from "src/components/LoggedInAdminProvider";
import PageTitle from "src/components/PageTitle";

import OrgSubaccountsEnable from "./OrgSubaccountsEnable";
import OrgSubaccountsList from "./OrgSubaccountsList";

export default function OrgSubaccounts(): JSX.Element {
  const tenant = useTenant()!;

  return (
    <Container>
      <PageTitle title="Subaccounts" />
      {tenant.isUsingSubaccounts ? (
        <OrgSubaccountsList />
      ) : (
        <OrgSubaccountsEnable />
      )}
    </Container>
  );
}
